const utilityPanelIsOpen = state => {
  const { player } = state;
  const { view } = player;
  const { utilityPanel = false } = view;
  return utilityPanel === true;
};

export default utilityPanelIsOpen;
